(() => {
  const elementName = 'aceii-expert-videos';

  if (window.customElements.get(elementName)) return;

  class AceiiExpertVideos extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;

      this.abortController = new AbortController();
      this.track = this.querySelector('[data-expert-video-track]');
      this.cards = Array.from(this.querySelectorAll('.aceii-expert-videos__card'));
      this.dots = Array.from(this.querySelectorAll('[data-expert-video-dot]'));

      if (!this.track || this.cards.length < 2) return;

      const eventOptions = { signal: this.abortController.signal };
      this.track.addEventListener('scroll', this.handleScroll, { ...eventOptions, passive: true });
      this.addEventListener('click', this.handleClick, eventOptions);
      window.addEventListener('resize', this.handleResize, eventOptions);
      this.updateActiveDot();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
      cancelAnimationFrame(this.scrollFrame);
    }

    handleClick = (event) => {
      const dot = event.target.closest('[data-expert-video-dot]');
      if (!dot || !this.contains(dot) || !this.track) return;

      const card = this.cards[Number(dot.dataset.expertVideoDot)];
      if (!card) return;

      this.track.scrollTo({ left: card.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
    };

    handleScroll = () => {
      cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = requestAnimationFrame(() => this.updateActiveDot());
    };

    handleResize = () => this.updateActiveDot();

    updateActiveDot() {
      if (!this.track || !this.cards?.length) return;

      const target = this.track.scrollLeft;
      let activeIndex = 0;
      let closestDistance = Infinity;

      this.cards.forEach((card, index) => {
        const distance = Math.abs(card.offsetLeft - this.track.offsetLeft - target);
        if (distance < closestDistance) {
          closestDistance = distance;
          activeIndex = index;
        }
      });

      this.dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', String(isActive));
      });
    }
  }

  window.customElements.define(elementName, AceiiExpertVideos);
})();
